import { useEffect, useState } from 'react';

import { User } from 'firebase/auth';

import SectionApi from '../../api/sectionApi';
import StatApi from '../../api/statApi';
import { SectionDataWithProgress } from '../../types/compound/progressTypes';
import SectionData from '../../types/SectionData';
import SkillData from '../../types/skillData';

export default function useSectionsWithProgress(
  skill: SkillData | undefined,
  user: User | null | undefined
): [SectionDataWithProgress[] | undefined, SectionData[] | undefined, (completedSection: SectionData) => void] {
  const [sections, setSections] = useState<SectionDataWithProgress[]>();
  const [sectionsWithoutProgress, setSectionWithoutProgress] = useState<SectionData[]>();

  useEffect(() => {
    async function fetchData() {
      if (!skill) return;
      if (!user) {
        const fetchedSections = await SectionApi.getSectionsBySkillId(skill.id);
        setSectionWithoutProgress(fetchedSections);
      } else {
        const fetchedSections = await SectionApi.getSectionsBySkillId(skill.id);
        const fetchedSectionsIds = fetchedSections.map(section => section.id);
        const fetchedSectionStats = await StatApi.getStatsWithTargetIdsAndUserId(fetchedSectionsIds, user.uid);
        const completedSections: SectionDataWithProgress[] = fetchedSections.map(section => {
          const complete = fetchedSectionStats.some(stat => stat.targetId === section.id);
          return { ...section, complete };
        });
        setSections(completedSections);
      }
    }
    fetchData();
  }, [skill, user]);

  function markSectionAsComplete(completedSection: SectionData) {
    setSections(sections =>
      sections?.map(section =>
        section.id === completedSection.id
          ? {
              ...section,
              complete: true,
            }
          : section
      )
    );
  }

  return [sections, sectionsWithoutProgress, markSectionAsComplete];
}
